// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3r1u9","col":"CardReaderDesc_col__XElYu","label":"CardReaderDesc_label__3ZZ3d"};